export enum StockInTargetType {
    Employee = 1,
    Partner = 2
}